'use client';

import { PRODUCT_OFFER_SORT_OPTIONS } from '@/constants/productSort';

import { ProductSortBarProps } from './models';
import { SortBar } from './SortBar';

export { SortBar } from './SortBar';

const ProductSortBar = ({ options = PRODUCT_OFFER_SORT_OPTIONS, ...props }: ProductSortBarProps) => <SortBar {...props} options={options} />;

export default ProductSortBar;
